import request from '../utils/request';
import { endpoint } from '../utils/config';

export async function getRequestForms(data) {
  const url = `${endpoint}/requestForms`;
  return await request({
    url,
    method: 'get',
    data
  });
}
export async function getAllRequests(data) {
  const url = `${endpoint}/requests`;
  return await request({
    url,
    method: 'get',
    data
  });
}
export async function getActivities(data) {
  const url = `${endpoint}/activity`;
  return await request({
    url,
    method: 'get',
    data
  });
}
export async function getRequestsByStatus(data) {
  const url = `${endpoint}/requests/aggregateByStatus`;
  return await request({
    url,
    method: 'get',
    data
  });
}

export async function getExportReportAsCsv(emails) {
  const url = `${endpoint}/requests/sendCsv?to=${emails}`
  return await request({
    url,
    method: 'get',
  });
}

export async function getExportReportAsPdf(emails) {
  const url = `${endpoint}/requests/sendPdf?to=${emails}`
  return await request({
    url,
    method: 'get',
  });
}

export async function getUserRequestsByStatus(id) {
  const url = `${endpoint}/requests/aggregateByStatus/${id}`;
  return await request({
    url,
    method: 'get',
  });
}

export async function postRequestForm(data) {
  const url = `${endpoint}/requestForms`;
  return await request({
    url,
    method: 'post',
    data
  });
}

export async function deleteRequestForm(id) { 
  const url = `${endpoint}/requestForms/${id}`;
  return await request({
    url,
    method: 'delete',
  });
}
export async function putRequestForm({data, id}) { 
  const url = `${endpoint}/requestForms/${id}`;
  return await request({
    url,
    method: 'put',
    data,
  });
}
